import { use } from 'react';
import { PageTransitionProviderContext } from './PageTransitionProvider';

export const usePageTransition = () => use(PageTransitionProviderContext);
